import type { ColumnDefinition } from "@frui.ts/dataviews/dist";
import React from "react";
import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import PayGateTransactionsViewModel from "viewModels/finance/payGateTransactions/payGateTransactionsViewModel";
import type PayGateTransaction from "entities/payGateTransaction";
import { formatAmount } from "utils/localizations";
import monthName from "utils/monthName";
import upperFirst from "lodash/upperFirst";
import ListView from "../../common/list";
import PayGateTransactionFilters from "./payGateTransactionFilter";

const PayGateTransactionsView: ViewComponent<PayGateTransactionsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<PayGateTransaction>[] = [
    {
      title: vm.translate("period"),
      valueFormatter: props => {
        const { year, month } = props.item;
        return `${year} - ${upperFirst(monthName(month))}`;
      },
    },
    {
      property: "bruttoAmount",
      title: vm.translateAttribute("bruttoAmount"),
      valueFormatter: props => formatAmount(props.value),
    },
    {
      property: "nettoAmount",
      title: vm.translateAttribute("nettoAmount"),
      valueFormatter: props => formatAmount(props.value),
    },
    {
      property: "commissionFee",
      title: vm.translateAttribute("commissionFee"),
      valueFormatter: props => formatAmount(props.value),
    },
  ];

  return <ListView vm={vm} columns={columns} aboveTable={<PayGateTransactionFilters vm={vm} />} />;
});

registerView(PayGateTransactionsView, PayGateTransactionsViewModel);
